import {
  IScanPackageToAddData,
  IScanPackageToAddDataRaw,
} from '../../../types';

/**
 * This function will format scan package to add api response to add required
 * fallback values.
 */
export const formatScanPackageToAddResponse = (
  data: IScanPackageToAddDataRaw
): IScanPackageToAddData => {
  const {
    boxIdentifier,
    inventoryData: {
      appraisalCode = 'N/A',
      courierProvider = 'N/A',
      barCode = 'None',
      assetName = 'None',
    } = {},
    multipleInventories,
    packageIdentifier,
    podInfo,
    trayInfo,
  } = data;

  return {
    boxIdentifier,
    inventoryData: { appraisalCode, courierProvider, barCode, assetName },
    multipleInventories,
    packageIdentifier,
    podInfo,
    trayInfo,
  };
};
